import React from 'react';
import { ScreenContainer, ContentFrame, LayoutContent, } from '@pinwheel/origami';
import ModalHeader from '../components/ModalHeader';
import ManualInstructions from '../LinkApiRouter/views/ManualInstructions';
var ManualInstructionsDisplay = function () {
    return (React.createElement(ScreenContainer, null,
        React.createElement(ModalHeader, { showPlatformLogo: true }),
        React.createElement(ContentFrame, null,
            React.createElement(LayoutContent, null,
                React.createElement(ManualInstructions, null)))));
};
export default ManualInstructionsDisplay;
